import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { useModal } from '@shared/lib';
import { Button } from '@shared/ui/molecules';
export interface SteamLoginModalProps {
  isModalActive: boolean;
  handleModalClose: () => void;
}
interface WhereToFindSteamLoginButtonProps {
  renderSteamLoginModal: (props: SteamLoginModalProps) => ReactNode;
}
const WhereToFindSteamLoginButton: FC<WhereToFindSteamLoginButtonProps> = ({
  renderSteamLoginModal
}) => {
  const {
    isModalActive,
    handleModalClose,
    handleModalOpen
  } = useModal();
  return <WhereToFindSteamLoginButtonWrapper>
      <Button type="button" variant="secondary" size="44" family="MTSCompact" transform="none" onClick={handleModalOpen}>
        Где найти?
      </Button>
      {renderSteamLoginModal({
      isModalActive,
      handleModalClose
    })}
    </WhereToFindSteamLoginButtonWrapper>;
};
export default WhereToFindSteamLoginButton;
const WhereToFindSteamLoginButtonWrapper = /*#__PURE__*/styled('div')({
  name: "WhereToFindSteamLoginButtonWrapper",
  class: "wzzfre",
  propsAsIs: false
});

require("./WhereToFindSteamLoginButton.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./WhereToFindSteamLoginButton.tsx");